import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $(this.element).tooltip({
      container: "body",
    });
  }

  disconnect() {
    $(this.element).tooltip("destroy");
  }
}
